import React from 'react';
import Slider from 'react-slick';
import './SocialProofSection.css';
import ProjectsCarousel from './ProjectsCarousel';

// Import all client logo images

import Clientlogo25 from '../images/Clientlogo25.png';
import Clientlogo27 from '../images/Clientlogo27.png';
import Clientlogo28 from '../images/Clientlogo28.png';
import Clientlogo29 from '../images/Clientlogo29.png';
import Clientlogo30 from '../images/Clientlogo30.png';
import Clientlogo31 from '../images/Clientlogo31.png';
import Clientlogo32 from '../images/Clientlogo32.png';
import Clientlogo33 from '../images/Clientlogo33.png';
import Clientlogo34 from '../images/Clientlogo34.png';
import Clientlogo35 from '../images/Clientlogo35.png';
import Clientlogo36 from '../images/Clientlogo36.png';
import Clientlogo37 from '../images/Clientlogo37.png';
import Clientlogo38 from '../images/Clientlogo38.png';
import Clientlogo39 from '../images/Clientlogo39.png';
import Clientlogo40 from '../images/Clientlogo40.png';

const SocialProofSection = () => {
  const clientLogos = [
    Clientlogo25, Clientlogo27, Clientlogo28, Clientlogo29,
    Clientlogo30, Clientlogo31, Clientlogo32, Clientlogo33, Clientlogo34,
    Clientlogo35, Clientlogo36, Clientlogo37, Clientlogo38, Clientlogo39,
    Clientlogo40
  ];

  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 2000,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  };

  return (
    <section className="social-proof-section">
      <div className="social-proof-wrapper">
        <div id="clients" className="clients-container">
          <div className="clients-header">
            <h1 className="clients-title">Our <br />
            Clients</h1>
            <p className="clients-subtitle">
              Organizations that have trusted us globally
            </p>
            <div className="clients-divider"></div>
          </div>

          <div className="clients-slider">
            <Slider {...settings}>
              {clientLogos.map((logo, index) => (
                <div key={index}>
                  <div className="client-logo-item">
                    <img 
                      src={logo} 
                      alt={`Client logo ${index + 1}`} 
                      className="client-logo"
                    />
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
        
        <div id="projects">
          <ProjectsCarousel />
        </div>
        
      </div>
    </section>
  );
};

export default SocialProofSection;
